import { useContext } from 'react';
import { StoreContext } from '@roc/client-portal-shared/context';
import { ExpectedClosingsStore } from '../stores/expectedClosingsStore';

export const useExpectedClosingsStore = () => {
  return useContext<{
    expectedClosingsStore: ExpectedClosingsStore;
  }>(StoreContext);
};
